import { IconType } from "react-icons";
import {
  NoOption,
  Option,
  OptionsContainer,
  OptionsList,
  SelectContainer,
} from "./index.styled";
import { DefaultTheme } from "styled-components";
import { useState } from "react";
import { FiChevronDown, FiChevronUp } from "react-icons/fi";
import Backdrop from "../../backdrop/backdrop";

export const CREATE_NEW_OBJECT_VALUE = "create-new-object-value";

export interface OptionProps {
  label: string;
  value: string;
}

interface AutoCompleteSelectProps {
  value?: OptionProps;
  setValue?: (value: OptionProps) => void;
  inputValue?: string;
  setInputValue?: (value: string) => void;
  placeholder?: string;
  icon?: IconType;
  allowWrite?: boolean;
  backgroundColor?: keyof DefaultTheme["colors"] | "transparent";
  primaryColor?: keyof DefaultTheme["colors"] | string;
  secondaryColor?: keyof DefaultTheme["colors"] | string;
  options?: OptionProps[];
  tabIndex?: number;
}
const AutoCompleteSelect: React.FC<AutoCompleteSelectProps> = ({
  value,
  setValue,
  inputValue,
  setInputValue,
  icon: Icon,
  placeholder,
  allowWrite = true,
  primaryColor = "white",
  secondaryColor = "black",
  backgroundColor = "transparent",
  options = [],
  tabIndex = 0,
}) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);

  const handleSelect = (option: OptionProps) => {
    if (allowWrite) {
      option.value !== CREATE_NEW_OBJECT_VALUE &&
        setInputValue &&
        setInputValue(option.label);
    }
    setValue && setValue(option);
    setIsOpen(false);
  };

  return (
    <SelectContainer
      primaryColor={primaryColor}
      secondaryColor={secondaryColor}
      backgroundColor={backgroundColor}
      onClick={(e) => e.target.dispatchEvent(new Event("focus"))}
      onFocus={() => setIsOpen(true)}
      onBlur={() => setIsOpen(false)}
      tabIndex={tabIndex}
    >
      {Icon && <Icon />}
      <input
        type="text"
        placeholder={placeholder}
        onFocus={() => setIsOpen(true)}
        disabled={!allowWrite}
        value={allowWrite ? inputValue : value?.label}
        onChange={(e) => setInputValue && setInputValue(e.target.value)}
      />
      <span>{!isOpen ? <FiChevronDown /> : <FiChevronUp />}</span>

      {isOpen && (
        <Backdrop
          isShown={true}
          toggle={() => setIsOpen(!isOpen)}
          transparent={true}
          zIndex={5}
        />
      )}

      {isOpen && (
        <OptionsContainer>
          <OptionsList>
            {options.map((option, index) => (
              <Option key={option.value} onClick={() => handleSelect(option)}>
                {option.label}
              </Option>
            ))}
            {options.length === 0 && <NoOption>No options</NoOption>}
          </OptionsList>
        </OptionsContainer>
      )}
    </SelectContainer>
  );
};

export default AutoCompleteSelect;
